import { Language } from "../../types/Language";

export default function isLanguage(val: any): val is Language {
  return Object.values(Language).includes(val);
}
